import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CART_SUGGESTION_CARDS_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { CartSuggestionCardsBlockScenarioContent } from '@front-platform/content-builder';
import {
  CART_SUGGESTION_CARDS_BLOCK_LOADING_VM,
  CartSuggestionCardsBlockDataSource,
  CartSuggestionCardsBlockViewModel,
} from './cart-suggestion-cards-block-view-model';

export function toCartSuggestionCardsPreviewViewModel(
  content: CartSuggestionCardsBlockScenarioContent,
): CartSuggestionCardsBlockViewModel {
  const products = content.suggestions as unknown as NonNullable<
    CartSuggestionCardsBlockViewModel['suggestions']['value']
  >;
  return {
    suggestions: {
      hasValue: true,
      value: [...products],
      isLoading: false,
    },
  };
}

@Injectable()
export class CartSuggestionCardsBlockPreviewDataSource implements CartSuggestionCardsBlockDataSource {
  readonly vm$: Observable<CartSuggestionCardsBlockViewModel> = previewScenarioForBloc$(
    CART_SUGGESTION_CARDS_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return CART_SUGGESTION_CARDS_BLOCK_LOADING_VM;
      }
      const content = previewScenarioData<CartSuggestionCardsBlockScenarioContent>(
        scenario,
        CART_SUGGESTION_CARDS_BLOCK_COMPONENT,
      );
      return content
        ? toCartSuggestionCardsPreviewViewModel(content)
        : CART_SUGGESTION_CARDS_BLOCK_LOADING_VM;
    }),
  );
}
